import { Clickable, Col, Row, Text } from 'components';
import { closeNotifs, theme } from 'lib';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Image = styled.img`
  width: 48px;
  height: 64px;
  object-fit: cover;
`;

const ClickableBold = ({ onClick, children }) => (
  <Clickable onClick={onClick}>
    <Text bold>{children}</Text>
  </Clickable>
);

const PostComment = ({ data }) => {
  const { sender, timestamp, entityId } = data,
    navigate = useNavigate(),
    dispatch = useDispatch(),
    { t } = useTranslation(),
    posts = useSelector((state) => state.user.posts),
    post = posts.find((x) => x._id === entityId),
    thumbnail = post?.metaData
      ? post.metaData.image || post.metaData.icon || ''
      : post?.youtubeId
        ? `https://img.youtube.com/vi/${post.youtubeId}/0.jpg`
        : post?.media?.length
          ? post.media[0]?.thumbnail || post.item?.oldMedia[0]
          : null;

  return (
    <Clickable
      onClick={() => {
        closeNotifs();
        navigate(`/post/${entityId}`);
      }}
    >
      <Row noFlex pad="0 0 16px" center>
        <Image src={thumbnail} />

        <Col marg="0 0 0 16px" center>
          <Row between start>
            <Trans
              parent={Text}
              components={{
                strong: (
                  <ClickableBold
                    onClick={() => {
                      closeNotifs();
                      navigate(`/profile/${sender.username}`);
                    }}
                  />
                )
              }}
            >
              {t('notifications.commentedToPost', { sender: sender.name || sender.username })}
            </Trans>

            <Text b2 med col={theme.GREY_60}>
              {timestamp}
            </Text>
          </Row>
        </Col>
      </Row>
    </Clickable>
  );
};

export default PostComment;
